// import { useQuery, useQueryClient } from "@tanstack/react-query";

// const getExpenses = async () => ({
//   expenses: [
//     {
//       id: "1",
//       expenseNumber: "EXP-001",
//       expenseType: "operating",
//       date: "2025-01-10",
//       vendorName: "Al Salam Properties",
//       category: "Rent",
//       amount: 15000.0,
//       amountDue: 15000.0,
//       status: "unpaid",
//       vatRate: 15,
//     },
//     {
//       id: "2",
//       expenseNumber: "EXP-002",
//       expenseType: "bill",
//       date: "2025-01-18",
//       vendorName: "TechSupply Arabia",
//       category: "Office Expense",
//       amount: 8750.5,
//       amountDue: 0,
//       status: "paid",
//       vatRate: 15,
//     },
//     {
//       id: "3",
//       expenseNumber: "EXP-003",
//       expenseType: "equipment",
//       date: "2025-01-25",
//       vendorName: "Dell Arabia",
//       category: "IT Equipment",
//       amount: 12500.0,
//       amountDue: 6250.0,
//       status: "partial",
//       vatRate: 15,
//     },
//     {
//       id: "4",
//       expenseNumber: "EXP-004",
//       expenseType: "operating",
//       date: "2025-02-01",
//       vendorName: "Gulf Advertising Co.",
//       category: "Advertisement",
//       amount: 3200.0,
//       amountDue: 3200.0,
//       status: "overdue",
//       vatRate: 15,
//     },
//     {
//       id: "5",
//       expenseNumber: "EXP-005",
//       expenseType: "bill",
//       date: "2025-02-12",
//       vendorName: "Saudi Stationery",
//       category: "Office Expense",
//       amount: 980.0,
//       amountDue: 0,
//       status: "paid",
//       vatRate: 15,
//     },
//   ],
// });

// export const useGetExpenses = () => {
//   const queryClient = useQueryClient();
//   return useQuery({
//     queryKey: ["expenses"],
//     queryFn: getExpenses,
//     initialData: () => queryClient.getQueryData(["expenses"]),
//     select: (data) => data.expenses,
//     staleTime: 1000 * 60 * 50,
//   });
// };

import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getExpenses } from "api/expense.api";
import { gracefulList } from "lib/queryHelpers";
import { QUERY_KEYS } from "config/queryKeys";
import { DEFAULT_STALE_TIME } from "config/constants";

/** Backend documentType → the table's short expenseType. */
const TYPE_MAP = {
  operating_expense: "operating",
  office_equipment: "equipment",
  bill: "bill",
};

/** Map a backend purchase document to the shape ExpenseTable expects. */
const mapDocument = (doc) => ({
  id: doc.id || doc._id,
  expenseNumber: doc.documentNumber,
  expenseType: TYPE_MAP[doc.documentType] || doc.documentType,
  date: doc.documentDate,
  vendorName: doc.vendorName || "—",
  category: doc.category || "",
  amount: doc.totalAmount ?? 0,
  amountDue: doc.balanceDue ?? 0,
  status: (doc.status || "unpaid").toLowerCase(),
  vatRate: doc.lineItems?.[0]?.taxRate ?? 15,
  raw: doc,
});

export const useGetExpenses = (params = {}) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: QUERY_KEYS.expenses.list(),
    queryFn: gracefulList(() => getExpenses(params), { documents: [] }),
    initialData: () => queryClient.getQueryData(QUERY_KEYS.expenses.list()),
    select: (data) => (data?.documents || []).map(mapDocument),
    staleTime: DEFAULT_STALE_TIME,
  });
};
